import React from "react";
import {
  Grid,
  CardContent,
  CardHeader,
  Card,
  Divider,
} from "@material-ui/core";
import WeeklyTradesReportTable from "./WeeklyTradesReportTable";
import { usePageStyles } from "../../pageStyles";
import { PageComponent } from "../../../core/navigation/types";
import { PageTitle } from "../../components/common/PageTitle";
//import { WeeklyTradesReportFilter } from "./WeeklyTradesReportFilter";
import { DownloadButton, DownloadExcelButton } from "./DownloadButton";
import { WTRFilterButton } from "./WTRFilter";

const WeeklyTradesReport: PageComponent = ({ userAccessRights }) => {
  const pageStyles = usePageStyles();

  return (
    <>
      <Grid container className={pageStyles.root}>
        <Grid item xs={12} className={pageStyles.gridItem}>
          <Card>
            <CardHeader
              title={<PageTitle title="weeklyTradeReportTitle" />}
              action={<WeekActions />}
            />
            <Divider />
            <CardContent>
              <WeeklyTradesReportTable userAccessRights={userAccessRights} />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </>
  );
};

export const WeekActions: React.FunctionComponent = () => (
  <Grid container>
    <Grid item>
      <WTRFilterButton />
    </Grid>
    <Grid item>
      <DownloadButton />
    </Grid>
    <Grid item>
      <DownloadExcelButton />
    </Grid>
  </Grid>
);

export default WeeklyTradesReport;
